/**
 * DocBlock — wrapper that gives an assistant message its document-first
 * character: a Batemo "Kachel" gradient tile (matching the rest of the app),
 * with slots for header / body / footer regions. Response state (streaming /
 * aborted / error) is signalled by the tile's border tint plus the brand
 * author-dot — not the old orange left-accent bar.
 *
 * This is purely a layout primitive. It does NOT render the message content
 * itself — that's the caller's responsibility (ChatMessage composes a
 * DocBlock around AuthorHeader + MarkdownRenderer + ReasoningToggle).
 */

/**
 * @param {object} props
 * @param {boolean} [props.streaming=false] — when true, slightly brightens the marker
 * @param {boolean} [props.aborted=false] — dims the marker for cancelled responses
 * @param {boolean} [props.error=false] — flips marker to error colour
 * @param {import('preact').ComponentChildren} props.children
 */
export function DocBlock({ streaming = false, aborted = false, error = false, children }) {
  const stateClass = error
    ? 'ion-doc-block--error'
    : aborted
      ? 'ion-doc-block--aborted'
      : streaming
        ? 'ion-doc-block--streaming'
        : ''

  return (
    <article class={`ion-doc-block ${stateClass}`.trim()}>
      {children}
    </article>
  )
}
